import React from 'react';
import { useTranslation } from 'react-i18next';

interface IndicatorsProps {}

const Indicator: React.FC<IndicatorsProps> = () => {
    const { t , i18n } = useTranslation();

    return (
        <div className="indicators">
            <div className="x">
                <div className="level left">0</div>
                <div className="indication">{t('Volkswirtschaftliche Bedeutung')}</div>
                <div className="level right">10</div>
            </div>

            <div className={`y ${i18n.language}`}>
                <div className="level left">0</div>
                <div className="indication">{t('Forschungskompetenz')}</div>
                <div className="level right">10</div>
            </div>
        </div>
    );
};

export default Indicator;